import React, { useState, useEffect } from 'react';
import { fetchWithAuth } from "../utils/fetchWithAuth";

const WritingAssistant = () => {
  const [writings, setWritings] = useState([]);
  const [newWritingTitle, setNewWritingTitle] = useState('');

  useEffect(() => {
    const fetchWritings = async () => {
      try {
        const response = await fetchWithAuth('/api/list_writing');
        if (response.ok) {
          const data = await response.json();
          setWritings(data);
        } else {
          console.error('Failed to fetch writings:', response.statusText);
        }
      } catch (error) {
        console.error('Error fetching writings:', error);
      }
    };

    fetchWritings();
  }, []);

  const handleCreateWriting = async () => {
    if (!newWritingTitle.trim()) {
      alert('Writing title cannot be empty.');
      return;
    }

    try {
      const response = await fetchWithAuth('/api/create_writing', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ title: newWritingTitle }),
      });

      if (response.ok) {
        const newWriting = await response.json();
        setWritings([...writings, newWriting]);
        setNewWritingTitle(''); // Clear input
      } else {
        console.error('Failed to create writing:', response.statusText);
      }
    } catch (error) {
      console.error('Error creating writing:', error);
    }
  };

  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 px-6 py-8">
        <div className="mx-auto max-w-7xl">
          <div className="mb-6 flex items-center justify-between">
            <h2 className="text-3xl font-bold text-[var(--text-primary)]">My Writings</h2>
          </div>
          <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-6">
            {/* New Writing Card */}
            <div
              className="group relative flex cursor-pointer flex-col items-center justify-center rounded-lg border-2 border-dashed border-gray-300 bg-white p-6 text-center transition-colors hover:border-[var(--primary-color)] hover:bg-[var(--primary-color-light)]"
              onClick={handleCreateWriting} // Trigger creation on click
            >
              <div className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-[var(--primary-color-light)] text-[var(--primary-color)] group-hover:bg-white">
                <span className="material-symbols-outlined text-4xl">add</span>
              </div>
              <h3 className="text-lg font-semibold text-[var(--text-primary)]">New Writing</h3>
              <input
                type="text"
                placeholder="Enter title"
                className="mt-2 p-2 border rounded w-full text-center"
                value={newWritingTitle}
                onChange={(e) => setNewWritingTitle(e.target.value)}
                onClick={(e) => e.stopPropagation()} // Prevent card click when typing
              />
              <p className="mt-1 text-sm text-[var(--text-secondary)]">Start with a blank page or upload a file.</p>
            </div>

            {/* Existing Writings */}
            {writings.map((writing) => (
              <div
                key={writing.id} // Assuming each writing has a unique 'id'
                className="group relative flex cursor-pointer flex-col overflow-hidden rounded-lg bg-white shadow-sm transition-shadow hover:shadow-lg"
              >
                <div className="flex h-40 w-full items-center justify-center bg-gray-100 text-gray-400">
                  <svg
                    className="h-16 w-16"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1"
                    viewBox="0 0 24 24"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    ></path>
                  </svg>
                </div>
                <div className="flex-1 p-4">
                  <h3 className="font-semibold text-[var(--text-primary)]">{writing.title}</h3>
                  <p className="text-sm text-[var(--text-secondary)]">
                    Edited {new Date(writing.lastEdited).toLocaleDateString()} {/* Assuming 'lastEdited' field */}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default WritingAssistant;